// src/AboutModal.jsx
import React from "react";

export default function AboutModal({
  open,
  onClose,
  version = process.env.REACT_APP_VERSION || "dev",
  buildDate = process.env.REACT_APP_BUILD_DATE || "",
}) {
  if (!open) return null;

  const linkStyle = { color: "#0b6efb", textDecoration: "none", fontWeight: 600 };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,.35)",
        display: "grid", placeItems: "center", zIndex: 1000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="about-title"
        style={{
          width: 680, maxWidth: "92vw", background: "#fff",
          borderRadius: 14, padding: 24, boxShadow: "0 24px 60px rgba(0,0,0,.2)"
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
          <img
            src="/icons/icon-192.png"
            alt="PlaysWithGuru"
            width="56"
            height="56"
            style={{ borderRadius: 12 }}
          />
          <div>
            <h2 id="about-title" style={{ margin: 0, fontSize: 28 }}>PlaysWithGuru</h2>
            <div style={{ opacity: .7, fontSize: 14 }}>
              Version {version}{buildDate ? ` • ${buildDate}` : ""}
            </div>
          </div>
        </div>

        {/* Tagline */}
        <p style={{ fontSize: 20, lineHeight: 1.5, marginTop: 18 }}>
          Smart prop predictions and fantasy insights. Play like a guru.
        </p>

        {/* Copyright */}
        <p style={{ marginTop: 18, opacity: .9 }}>
          © {new Date().getFullYear()} PlaysWithGuru. All rights reserved.
        </p>

        {/* Useful links */}
        <div style={{
          marginTop: 8, display: "flex", gap: 18, flexWrap: "wrap",
          borderTop: "1px solid #e5e7eb", paddingTop: 12
        }}>
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a>
            <a target="_blank" rel="noopener noreferrer"
            href="mailto:playswithguru@gmail.com?subject=Support%20request"
            style={linkStyle}
          >
            Contact Support
          </a>
        </div>


        {/* Actions */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 22 }}>
          <button onClick={onClose} className="btn-secondary">Close</button>
        </div>
      </div>
    </div>
  );
}
